import { createFileRoute } from '@tanstack/react-router';
import { ObjectAttributesTab } from '@/pages/workspaces/objects/object-detail/object-attributes-tab';
import { withRumPageRendered } from '@/services/rum/use-page-rendered';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/objects/$slug/$objectId/attributes/')({
  component: withRumPageRendered(ObjectAttributesTab),
});
